"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.brief.topic': 'Temat / brief',
    'socialMediaPlan.brief.topicPlaceholder': 'np. Premiera nowej kolekcji letniej z 20% rabatem...',
    'socialMediaPlan.brief.goal': 'Cel posta',
    'socialMediaPlan.brief.tone': 'Ton komunikacji',
    'socialMediaPlan.brief.contentType': 'Typ treści',
    'socialMediaPlan.brief.contentType.image': 'Obraz',
    'socialMediaPlan.brief.contentType.carousel': 'Karuzela',
    'socialMediaPlan.brief.contentType.video': 'Wideo',
    'socialMediaPlan.brief.contentType.story': 'Relacja',
    'socialMediaPlan.brief.contentType.thread': 'Wątek',
    'socialMediaPlan.brief.audience': 'Grupa docelowa',
    'socialMediaPlan.brief.cta': 'Wezwanie do działania (CTA)',
    'socialMediaPlan.brief.ctaPlaceholder': 'np. Kup teraz, Dowiedz się więcej, Zarejestruj się...',
    'socialMediaPlan.brief.platforms': 'Platformy docelowe',
    'socialMediaPlan.brief.platformsHint': 'AI dopasuje długość, styl i hashtagi osobno dla każdej wybranej platformy.',
};
